"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfEnquiryUserDetailsDto = instanceOfEnquiryUserDetailsDto;
exports.EnquiryUserDetailsDtoFromJSON = EnquiryUserDetailsDtoFromJSON;
exports.EnquiryUserDetailsDtoFromJSONTyped = EnquiryUserDetailsDtoFromJSONTyped;
exports.EnquiryUserDetailsDtoToJSON = EnquiryUserDetailsDtoToJSON;
exports.EnquiryUserDetailsDtoToJSONTyped = EnquiryUserDetailsDtoToJSONTyped;
/**
 * Check if a given object implements the EnquiryUserDetailsDto interface.
 */
function instanceOfEnquiryUserDetailsDto(value) {
    return true;
}
function EnquiryUserDetailsDtoFromJSON(json) {
    return EnquiryUserDetailsDtoFromJSONTyped(json, false);
}
function EnquiryUserDetailsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'] == null ? undefined : json['name'],
        'email': json['email'] == null ? undefined : json['email'],
        'phone': json['phone'] == null ? undefined : json['phone'],
    };
}
function EnquiryUserDetailsDtoToJSON(json) {
    return EnquiryUserDetailsDtoToJSONTyped(json, false);
}
function EnquiryUserDetailsDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'email': value['email'],
        'phone': value['phone'],
    };
}
